import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AlertReportComponentType, AlertReportTemplate, CreateAlertReportRequest, ExportAlertReportRequest, GenerateAlertReportRequest, NotifyAlertReportRequest, PreviewAlertReportRequest } from '../models/alert-report-template.model';

@Injectable({
  providedIn: 'root'
})
export class AlertReportService {
  private static readonly endpoints = {
    templates: `${environment.apiUrl}/alert-report-templates`,
    generateReport: `${environment.apiUrl}/alert-report-generate`,
    notifyReport: `${environment.apiUrl}/alert-report-notify`,
    componentTypes: `${environment.apiUrl}/alert-report-component-types`,
    exportAlerts: `${environment.apiUrl}/alert-report-export`,
  };

  private httpClient = inject(HttpClient);

  getTemplates(): Observable<AlertReportTemplate[]> {
    return this.httpClient.get<AlertReportTemplate[]>(AlertReportService.endpoints.templates);
  }

  getTemplateById(id: string): Observable<AlertReportTemplate> {
    return this.httpClient.get<AlertReportTemplate>(`${AlertReportService.endpoints.templates}/${id}`);
  }

  getTemplatePreview(id: string, payload: PreviewAlertReportRequest): Observable<string> {
    return this.httpClient.post(`${AlertReportService.endpoints.templates}/${id}/preview`, payload, {
      responseType: 'text'
    });
  }

  getComponentTypes(): Observable<AlertReportComponentType[]> {
    return this.httpClient.get<AlertReportComponentType[]>(AlertReportService.endpoints.componentTypes);
  }

  createTemplate(payload: CreateAlertReportRequest): Observable<AlertReportTemplate> {
    return this.httpClient.post<AlertReportTemplate>(AlertReportService.endpoints.templates, payload);
  }

  deleteTemplate(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${AlertReportService.endpoints.templates}/${encodeURIComponent(id)}`);
  }

  notifyRecipients(payload: NotifyAlertReportRequest): Observable<void> {
    return this.httpClient.post<void>(AlertReportService.endpoints.notifyReport, payload);
  }

  generateReport(payload: GenerateAlertReportRequest): Observable<Blob> {
    return this.httpClient.post(AlertReportService.endpoints.generateReport, payload, {
      responseType: 'blob'
    });
  }

  exportAlerts(payload: ExportAlertReportRequest): Observable<Blob> {
    return this.httpClient.post(AlertReportService.endpoints.exportAlerts, payload, {
      responseType: 'blob'
    });
  }
}
